import { createWorkItem } from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG } from "../../workLog/queries/useQueryWorkLog";
import { QUERY_WORK_LOGS } from "../../workLog/queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../../workLog/queries/useQueryWorkLogsSummary";
import { QUERY_WORK_ITEMS } from "../queries/useQueryWorkItems";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../resourceEvents/queries/useQueryListEvents";

export const useMutationCreateWorkItem = () =>
  useWSMutation<
    Awaited<ReturnType<typeof createWorkItem>>,
    WSServiceError,
    Parameters<typeof createWorkItem>[0]
  >(createWorkItem, {
    awaitDependencies: [
      QUERY_WORK_ITEMS,
      QUERY_WORK_LOG,
      QUERY_WORK_LOGS,
      QUERY_WORK_LOGS_SUMMARY,
      QUERY_LIST_RESOURCE_EVENTS
    ]
  });
